'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _nitroRipple = require('../nitro-ripple');

var _nitroRipple2 = _interopRequireDefault(_nitroRipple);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroToggle = function (_Component) {
  _inherits(NitroToggle, _Component);

  function NitroToggle(props) {
    _classCallCheck(this, NitroToggle);

    var _this = _possibleConstructorReturn(this, (NitroToggle.__proto__ || Object.getPrototypeOf(NitroToggle)).call(this, props));

    _initialiseProps.call(_this);

    var toggled = props.toggled,
        defaultToggled = props.defaultToggled,
        valueLink = props.valueLink;


    _this.state = {
      toggled: Boolean(toggled || defaultToggled || valueLink && valueLink.value)
    };
    return _this;
  }

  _createClass(NitroToggle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.toggled === 'boolean' && this.state.toggled !== nextProps.toggled) {
        this.setState({
          toggled: nextProps.toggled
        });
      }
    }
  }, {
    key: 'isToggled',
    value: function isToggled() {
      return this.state.toggled;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activeLabel = _props.activeLabel,
          className = _props.className,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          hideLabel = _props.hideLabel,
          label = _props.label,
          labelPosition = _props.labelPosition,
          labelVariant = _props.labelVariant,
          railWidth = _props.railWidth,
          rippleScaleInitial = _props.rippleScaleInitial,
          rippleScaleFinal = _props.rippleScaleFinal,
          transitionDuration = _props.transitionDuration,
          variant = _props.variant,
          wrapText = _props.wrapText;


      var toggled = this.state.toggled;

      var labelElement = hideLabel ? null : _react2.default.createElement(
        _styles.ToggleLabel,
        {
          disabled: disabled,
          labelPosition: labelPosition,
          labelVariant: labelVariant,
          toggled: toggled,
          variant: variant,
          wrapText: wrapText
        },
        toggled ? activeLabel : label
      );

      return _react2.default.createElement(
        _styles.ToggleWrapper,
        {
          className: className,
          disabled: disabled
        },
        labelPosition === 'left' && labelElement,
        _react2.default.createElement(_styles.ToggleInput, {
          toggled: toggled,
          className: 'checkbox',
          disabled: disabled,
          onChange: this.handleChange,
          type: 'checkbox'
        }),
        _react2.default.createElement(
          _styles.ToggleRailWrapper,
          {
            railWidth: railWidth
          },
          _react2.default.createElement(_styles.ToggleRail, {
            disabled: disabled,
            toggled: toggled,
            transitionDuration: transitionDuration,
            variant: variant
          }),
          _react2.default.createElement(
            _styles.ToggleSlider,
            {
              disabled: disabled,
              toggled: toggled,
              railWidth: railWidth,
              transitionDuration: transitionDuration,
              variant: variant
            },
            !disableRipple && _react2.default.createElement(_nitroRipple2.default, {
              scaleInitial: rippleScaleInitial,
              scaleFinal: rippleScaleFinal,
              ref: function ref(c) {
                _this2.ripple = c;
              },
              variant: toggled ? variant : 'base2'
            })
          )
        ),
        labelPosition === 'right' && labelElement,
        disabled && _react2.default.createElement(_utils.DisableCover, null)
      );
    }
  }]);

  return NitroToggle;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleChange = function (event) {
    var toggled = !_this3.state.toggled;
    _this3.setState({
      toggled: toggled
    });

    if (typeof _this3.props.action === 'function') {
      _this3.props.action(event, toggled);
    }
  };
};

NitroToggle.propTypes = {
  action: _propTypes2.default.func,
  activeLabel: _propTypes2.default.string,
  className: _propTypes2.default.string,
  defaultToggled: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  disableRipple: _propTypes2.default.bool,
  hideLabel: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelVariant: _propTypes2.default.string,
  railWidth: _propTypes2.default.string,
  rippleScaleFinal: _propTypes2.default.number,
  rippleScaleInitial: _propTypes2.default.number,
  toggled: _propTypes2.default.bool,
  transitionDuration: _propTypes2.default.number,
  variant: _propTypes2.default.string,
  wrapText: _propTypes2.default.bool
};

NitroToggle.defaultProps = {
  activeLabel: 'On',
  label: 'Off',
  labelPosition: 'left',
  railWidth: '36px',
  rippleScaleInitial: 1,
  rippleScaleFinal: 2,
  transitionDuration: 450,
  variant: 'primary'
};

exports.default = NitroToggle;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-toggle/NitroToggle.js
// module id = 3048
// module chunks = 4